<template>
    <a-cascader style="width:300px" :getPopupContainer="trigger => trigger.parentNode" v-if="showSearch" :fieldNames="{ label: 'name', value: 'value', children: 'children' }" :change-on-select="changeOnSelect"
                :show-search="{ filter }" :disabled="disabled"
                :value="selectedValue" :options="options" @change="onChange" :loadData="loadData" :placeholder="placeholder"/>
    <a-cascader style="width:300px" :getPopupContainer="trigger => trigger.parentNode" v-else :fieldNames="{ label: 'name', value: 'value', children: 'children' }" :change-on-select="changeOnSelect"
                :value="selectedValue" :options="options" @change="onChange" :loadData="loadData" :disabled="disabled" :placeholder="placeholder"/>
</template>

<script>
export default {
  name: 'DictCascader',
  props: {
    dictKey: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    value: {
      type: String
    },
    showSearch:{
      type: Boolean,
      default: true
    },
    changeOnSelect:{
      type: Boolean,
      default: true
    },
    separator:{
      type: String,
      default: ','
    },
    disabled:{
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  created () {
    if (this.value) {
      this.selectedValue = this.value.split(this.separator)
    }
    this.onFetch()
  },
  data () {
    return {
      options: [],
      selectedValue: []
    }
  },
  watch: {
    value (val) {
      if (!val) {
        this.selectedValue = []
        return
      }
      this.selectedValue = val.split(this.separator)
    }
  },
  methods: {
    loadData (selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true

      const that = this
      that.$http.get('/api/1/dict/cache/items.json?key=' + this.dictKey + '&id=' + targetOption.id).then(function (response) {
        targetOption.loading = false
        targetOption.children = [...response.result]

        that.options = [...that.options]
      })
    },
    onChange (value, selectedOptions) {
      this.selectedValue = value
      this.$emit('change', value.join(this.separator), selectedOptions)
    },
    onFetch () {
      const that = this
      that.$http.get('/api/1/dict/cache/items.json?key=' + this.dictKey).then(function (response) {
        that.options = [...response.result]
      })
    },
    filter(inputValue, path) {
      return path.some(option => option.name.indexOf(inputValue) > -1);
    }
  }
}
</script>

<style scoped>

</style>
